<template>
  <!-- Notificación de nueva versión disponible -->
  <v-snackbar
    v-model="showUpdatePrompt"
    :timeout="-1"
    color="primary"
    location="top"
    multi-line
    class="pwa-update-snackbar"
  >
    <div class="d-flex align-center">
      <v-icon class="mr-3" size="28">mdi-update</v-icon>
      <div>
        <div class="font-weight-bold text-body-1">Nueva versión disponible</div>
        <div class="text-caption mt-1">
          Actualiza para obtener las últimas mejoras y correcciones
        </div>
      </div>
    </div>

    <template #actions>
      <v-btn
        variant="text"
        size="small"
        color="white"
        @click="dismiss"
      >
        Después
      </v-btn>
      <v-btn
        variant="flat"
        color="secondary"
        size="small"
        :loading="updating"
        @click="update"
      >
        <v-icon start size="small">mdi-refresh</v-icon>
        Actualizar ahora
      </v-btn>
    </template>
  </v-snackbar>

  <!-- Notificación de app lista para offline -->
  <v-snackbar
    v-model="showOfflineReady"
    :timeout="4000"
    color="success"
    location="top"
  >
    <div class="d-flex align-center">
      <v-icon class="mr-2">mdi-check-circle</v-icon>
      <span>Aplicación lista para uso sin conexión</span>
    </div>
  </v-snackbar>
</template>

<script setup lang="ts">
import { computed, ref, watch } from 'vue'
import { usePWA } from '@/composables/usePWA'

const { needRefresh, offlineReady, updateApp, dismissUpdate } = usePWA()

const updating = ref(false)
const showOfflineReady = ref(false)

const showUpdatePrompt = computed({
  get: () => needRefresh.value,
  set: (val) => {
    if (!val) dismissUpdate()
  }
})

// Mostrar notificación cuando la app esté lista para offline
watch(offlineReady, (ready) => {
  if (ready) {
    showOfflineReady.value = true
  }
})

const update = async () => {
  updating.value = true
  try {
    await updateApp()
  } finally {
    updating.value = false
  }
}

const dismiss = () => {
  dismissUpdate()
}
</script>

<style scoped>
.pwa-update-snackbar :deep(.v-snackbar__content) {
  padding: 12px 16px;
}
</style>


